import { render, staticRenderFns } from "./Landscape.vue?vue&type=template&id=95c7c78c&scoped=true&lang=html&"
import script from "./Landscape.vue?vue&type=script&lang=js&"
export * from "./Landscape.vue?vue&type=script&lang=js&"
import style0 from "./Landscape.vue?vue&type=style&index=0&id=95c7c78c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c7c78c",
  null
  
)

export default component.exports